function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FF0000"
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  y1: -0.75,
  x2: 14.9858,
  y2: -0.75,
  transform: "matrix(-0.723833 -0.689975 0.723833 -0.689975 16 15)",
  stroke: "white",
  strokeWidth: 1.5
});

var SvgInputError = function SvgInputError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/InputError.72fbb948.svg";
export { SvgInputError as ReactComponent };